export default "__VITE_ASSET__sSveGJaB__"